import React from 'react';
import { Button } from '@mui/material';

interface PopupActionsProps {
  actionsList?: Array<any>;
  handleCloseButtonClick?: React.MouseEventHandler;
}

const PopupActions: React.FC<PopupActionsProps> = ({
  actionsList,
  handleCloseButtonClick,
}) => {
  return (
    <div className="popup-actions">
      {actionsList && actionsList.length > 0 ? (
        actionsList.map((element, index) => (
          <Button
            key={index}
            variant="contained"
            onClick={element.onClick}
            className={element.className}
          >
            {element.title}
          </Button>
        ))
      ) : (
        <Button
          variant="contained"
          onClick={handleCloseButtonClick}
          className="close-button"
        >
          Close
        </Button>
      )}
    </div>
  );
};

export default PopupActions;
